import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const GradientForceCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-gradient-force-calculator" />;

export default GradientForceCalculatorGuidePage;
